<div class="wa-table-details">
  <table class="wa-table-inner wa-table">
    <tbody class="wa-table-inner__row-group">
      <tr class="wa-table-inner__row wa-table-inner__row--simple">
        <td class="wa-table-inner__cell-caption" colspan="100%">{{'record_history' | transloco}}:</td>
      </tr>
      <tr class="wa-table__row visibility--hide-mobile" *ngFor="let Ranking of allData">
        <td class="wa-table__cell wa-table__cell--fit-right">
          <div class="ranking ranking--fit ranking--small" data-th="ranking" [ngClass]="{'ranking--square-small': Ranking.athlete.length === 1}">
            <div *ngIf="Ranking.athlete.length === 1 && ($any(filter_service.filtersType[2].options).options_subject.asObservable()|async) !== 'Team'; else: teamimage"
              class="ranking__picture">
              <img [lazyLoad]="'//extranet.worldarchery.sport/ProfilePictures/?Id=' + Ranking.athlete[0].Id" />
            </div>
            <ng-template #teamimage>
              <div class="ranking__picture">
                <img [lazyLoad]="'//extranet.worldarchery.sport/Flags/' + Ranking.teamnoc + '.svg'" />
              </div>
            </ng-template>
          </div>
        </td>
        <td class="wa-table__cell">
          <div *ngIf="Ranking.athlete" data-th="name">
            <div class="athlete" *ngFor="let athlete of Ranking.athlete">
              <a [href]="'/athlete/'+athlete?.Id.toString()">
                <span [ngClass]="athlete.WNameOrd === 1 ? 'athlete__lastname' : 'athlete__name'">
                  {{
                  athlete.WNameOrd === 1
                  ? athlete.FName
                  : athlete.GName
                  }}
                </span>
                <span [ngClass]="athlete.WNameOrd === 0 ? 'athlete__lastname' : 'athlete__name'">
                  {{
                  athlete.WNameOrd === 0
                  ? athlete.FName
                  : athlete.GName
                  }}
                </span>
              </a>
              <div class="athlete__img" *ngIf="athlete.NOC">
                <img [lazyLoad]="'//extranet.worldarchery.sport/Flags/' + athlete.NOC + '.svg'" />
              </div>
            </div>
          </div>
        </td>
        <td class="wa-table__cell">
          <div class="competition" data-th="competition">
            <a [href]="lang + 'competition/'+Ranking.event.Id.toString()" class="competition__name">{{Ranking.event.name}}</a>
            <div>
              <div class="competition__date"> {{Ranking.event.date | date : 'dd MMMM yyyy'}}</div>
              <div class="competition__place">{{Ranking.event.country}}</div>
              <div class="competition__country">
                <div class="competition__country__flag">
                  <img [lazyLoad]="'//extranet.worldarchery.sport/Flags/' + Ranking.event.NOC + '.svg'" />
                </div>
                <div class="competition__country__name">{{ getNameCountry(Ranking.event.NOC) }}</div>
              </div>
            </div>
          </div>
        </td>
        <td class="wa-table__cell">
          <div class="score score--secondary score--small" data-th="points">
            <span>{{Ranking.points}} </span>
            <span *ngIf="Ranking.xs!==undefined">{{Ranking.xs}}X </span>
          </div>
        </td>
      </tr>

      <div class="wa-table-simple visibility--hide-desktop wa-table-simple--inner" *ngFor="let Ranking of allData">
        <div class="wa-table-simple__cell">
          <div class="wa-table-simple__cell__item">
            <div class="ranking ranking--fit ranking--small" data-th="ranking" [ngClass]="{'ranking--square-small': Ranking.athlete.length === 1}">
              <div *ngIf="Ranking.athlete.length === 1 && ($any(filter_service.filtersType[2].options).options_subject.asObservable()|async) !== 'Team'; else: teamimage"
                class="ranking__picture">
                <img [lazyLoad]=" '//extranet.worldarchery.sport/ProfilePictures/?Id=' + Ranking.athlete[0].Id" />
              </div>
              <ng-template #teamimage>
                <div class="ranking__picture">
                  <img [lazyLoad]="'//extranet.worldarchery.sport/Flags/' + Ranking.teamnoc + '.svg'" />
                </div>
              </ng-template>
            </div>
          </div>
        </div>

        <div class="wa-table-simple__cell">
          <div class="wa-table-simple__cell__item">
            <div *ngIf="Ranking.athlete" data-th="name">
              <div *ngFor="let athlete of Ranking.athlete" class="athlete">
                <a [href]="lang + 'athlete/'+athlete?.Id.toString()">
                  <span [ngClass]="athlete.WNameOrd === 1 ? 'athlete__lastname' : 'athlete__name'">
                    {{
                    athlete.WNameOrd === 1
                    ? athlete.FName
                    : athlete.GName
                    }}
                  </span>
                  <span [ngClass]="athlete.WNameOrd === 0 ? 'athlete__lastname' : 'athlete__name'">
                    {{
                    athlete.WNameOrd === 0
                    ? athlete.FName
                    : athlete.GName
                    }}
                  </span>
                </a>
                <div class="athlete__img" *ngIf="athlete.NOC">
                  <img [lazyLoad]="'//extranet.worldarchery.sport/Flags/' + athlete.NOC + '.svg'" />
                </div>
              </div>
            </div>
          </div>
          <div class="wa-table-simple__cell__item">
            <div class="competition" data-th="competition">
              <div class="competition__name">{{Ranking.event.nameshort !== '' && Ranking.event.nameshort ? Ranking.event.nameshort : Ranking.event.name}}</div>
              <div>
                <div class="competition__date"> {{Ranking.event.date | date : 'dd MMMM yyyy'}}</div>
                <div class="competition__img">
                  {{Ranking.event.country}}
                  <img [lazyLoad]="'//extranet.worldarchery.sport/Flags/' + Ranking.event.NOC + '.svg'" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="wa-table-simple__cell wa-table-simple__cell--right">
          <div class="wa-table-simple__cell__item">
            <div class="score score--extra-small-double" data-th="points">
              <span>{{Ranking.points}} </span>
              <span *ngIf="Ranking.xs!==undefined">{{Ranking.xs}}X </span>
            </div>
          </div>
        </div>
      </div>

    </tbody>
  </table>
</div>
